import { Component, HostListener, OnInit } from '@angular/core'
import { AuthService } from '../../../../../services/auth.services'
import { RestServices } from '../../../../../services/rest.services'
import { FormBuilder } from '@angular/forms'
import { SharedServices } from '../../../../../services/shared.services'
import { ModalService } from '../../../../../services/modal.service'
import { ClientTopServices } from '../../../../../services/ClientTop.services'
import { notification } from 'onsenui'
import { imageUrl } from '../../../../../../helper/common'

@Component({
    selector: 'app-modal-list-image-top',
    templateUrl: './modal-list-image-top.component.html',
    styleUrls: [
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/main-view.component.css',
        '../../../../../stagingcss/image-viewer.component.css',
        './modal-list-image-top.component.css',
        '../../../../../stagingcss/lui-select.component.css',
    ],
})
export class ModalListImageTopComponent implements OnInit {
    modalListImageRegister = 'hidden'
    dataListArrayImageTop: any
    getAccessLog: object = null
    getAccountLog: object = null
    arrListCategory: any = []
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    en = {}
    showEN = true
    idClient
    resourceUrl = 'resource'
    showIconV = ''
    showImage = ''
    selectShowImageItem = ''
    showimageSelect = false
    index: any
    arayListNote: any
    planClass
    listImage: any = {}
    hostKeyboard: String = 'ModalListImageTopComponent-hostKeyboard'
    slideshowList = []
    pageActive = ''
    tabActive = ''
    newSlideshowIndex = -1
    newRegistrationIndex = -1
    faceImage

    showList: Array<string> = [
        'face-1',
        'face-2',
        'face-3',
        'face-4',
        'face-5',
        'face-6',
        'tooth-right',
        'tooth-front',
        'tooth-left',
        'tooth-upper',
        'tooth-overjet',
        'tooth-lower',
        'aligner-right',
        'aligner-front',
        'aligner-left',
        'aligner-upper',
        'aligner-overjet',
        'aligner-lower',
        'xp-1',
        'xp-2',
        'xp-3',
        'xp-4',
        'xp-5',
        'xp-6',
        'other-1',
        'other-2',
        'other-3',
        'other-4',
        'other-5',
        'other-6',
    ]

    constructor(
        private authData: AuthService,
        private restApi: RestServices,
        private formBuider: FormBuilder,
        private _sharedService: SharedServices,
        private modalService: ModalService,
        private clientTopServices: ClientTopServices,
    ) {
    }

    ngOnInit() {
        this.showImage = 'hidden'
        this.clientTopServices.changeEmittedListTopImageData$.subscribe(
            (success) => {
                if (success && success[0] === 'listDataImageTopClient') {
                    this.modalListImageRegister = 'active'
                    if (success[1]) {
                        this.pageActive = this.clientTopServices.returnPage()
                        this.tabActive = this.clientTopServices.getTabName()
                        const arrayListimage = []
                        let listImageCurren = []
                        if (this.pageActive == 'registration') {
                            listImageCurren = success[1]
                        } else {
                            let arrAll = this.clientTopServices.returnArrAll()
                            if (arrAll && arrAll['arrTmpArrClientTop']) {
                                listImageCurren = arrAll['arrTmpArrClientTop']
                            }
                            this.slideshowList = success[1]
                        }
                        if (listImageCurren && listImageCurren.length > 0) {
                            for (let i = 0; i < listImageCurren.length; i++) {
                                const itemImage = this.initJsonArayListImage(
                                    listImageCurren[i],
                                )
                                arrayListimage.push(itemImage)
                            }
                        }
                        this.dataListArrayImageTop = arrayListimage
                        this.getFiledCategory('arrListCategory')
                        this.idClient = success[2]
                        this.index = success[3]
                        this.arayListNote = success[4]
                    }
                }
            },
        )
    }

    getFiledCategory(arrListCategory) {
        this.arrListCategory = this.clientTopServices.showClientArrayTop(
            arrListCategory,
        )
    }

    hidenModalListImageRegister() {
        this.modalListImageRegister = 'hidden'
        this.clientTopServices.emitChangeListTopImageData(null)
    }

    moveRecordSelect(timeRecornd) {
        let keyTimeRecondMove = []
        if (this.pageActive == 'registration') {
            keyTimeRecondMove = [
                'ModalListImageTopComponent-keyTimeRecondMove',
                timeRecornd,
                this.index,
            ]
        } else {
            let record = this.convertSlideshowIndex(timeRecornd)
            if (record) {
                keyTimeRecondMove = [
                    'ModalListImageTopComponent-keyTimeRecondMove',
                    record.timeRecornd,
                    record.index,
                ]
            }
        }
        if (keyTimeRecondMove.length > 0) {
            this.clientTopServices.emitChange(keyTimeRecondMove)
            this.hidenModalListImageRegister()
        }
    }

    // convert selected index from table to corresponding index in slideshow
    convertSlideshowIndex(timeRecornd) {
        let result = null
        let found = this.slideshowList.findIndex((e) => {
            return e.dateStringToInit == timeRecornd
        })
        if (found != -1) {
            result = {
                timeRecornd: timeRecornd,
                index: found,
            }
        } else {
            let lower = null
            let lowerPos = -1
            let bigger = null
            let biggerPos = -1
            let foundBigger = false
            this.slideshowList.forEach((e, index) => {
                if (e.dateStringToInit < timeRecornd) {
                    lower = e
                    lowerPos = index
                } else if (e.dateStringToInit > timeRecornd && !foundBigger) {
                    bigger = e
                    biggerPos = index
                    foundBigger = true
                }
            })

            if (lower != null) {
                // previous record
                result = {
                    timeRecornd: lower.dateStringToInit,
                    index: lowerPos,
                }
            } else if (bigger) {
                // next record
                result = {
                    timeRecornd: bigger.dateStringToInit,
                    index: biggerPos,
                }
            }
        }
        return result
    }

    changeLanguage() {
        return (this.en = this.authData.showLang(this.showEN))
    }

    toggleTabItem(id, option, event) {
        this.planClass = id
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(
        event: KeyboardEvent,
        ModalListImageTopComponent: String = 'ModalListImageTopComponent-hostKeyboard',
    ) {
        if (ModalListImageTopComponent === this.hostKeyboard) {
            const keyPressed = event.keyCode
            if (keyPressed === 27) {
                event.preventDefault()
                this.hidenModalListImageRegister()
            }
        }
    }

    //update imgFace
    getFrontSmileToAvatar(arrImageClientTop) {
        const arrImageClientTopFrontSmile = arrImageClientTop
        for (let i = arrImageClientTopFrontSmile.length - 1; i >= 0; i--) {
            if (arrImageClientTopFrontSmile[i]['face-1'] != undefined && arrImageClientTopFrontSmile[i]['face-1'].length > 0 && arrImageClientTopFrontSmile[i]['face-1'][0]['id'] !== '') {
                return arrImageClientTopFrontSmile[i]['face-1'][0]
            } else if (i == 0) {
                return arrImageClientTopFrontSmile[i]['face-1'][0]
            }
        }
    }

    callApiUpdateFaceImage(imageFace) {
        const clientId = {}
        const result = this.idClient
        clientId[result] = true
        const resourceData = this.restApi.makeResourceObject({
            actions: [
                {
                    collection: 'client',
                    id: this.idClient,
                    type: 'update',
                    value: {
                        faceImage: imageFace,
                    },
                },
            ],
            status: {
                client: {
                    map: clientId,
                },
            },
        })
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.faceImage = success['response']['client']['map'][result]['faceImage']
                const imageFaceClient = ['ModalClientDetailRegistrationComponent-imageFaceClient', success['response']['client']['map'][result]['faceImage']]
                this._sharedService.emitChangeImageFace(imageFaceClient)
            })
        })
    }
    //end

    callApiRemoveRecornd(idClientVisit) {
        const clientId = {}
        const result = '{"clientId":"' + this.idClient + '"}'
        clientId[result] = true
        const resourceData = {
            actions: [
                {
                    type: 'remove',
                    id: idClientVisit[0],
                    collection: 'clientVisit',
                },
            ],
            status: {
                clientVisit: {
                    paths: clientId,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then((tokenReNew) => {
            this.restApi
            .http_post(this.resourceUrl, resourceData, tokenReNew)
            .subscribe((success) => {
                const listImageCurren =
                    success['response']['clientVisit']['paths'][
                    '' + result
                        ]
                this._sharedService.emitChange(['removeListOfImage', listImageCurren])
                const listImageCurrenDecode = this.clientTopServices.changeDateStringToDecoe(
                    listImageCurren,
                )
                const countArrDataRegistration =
                    listImageCurrenDecode.length
                const activeTab = this.clientTopServices.getTabName()
                if (countArrDataRegistration > 0) {
                    listImageCurrenDecode.sort(function(obj1, obj2) {
                        return (
                            obj1.dateStringToInit - obj2.dateStringToInit
                        )
                    })
                }
                const arrayListimage = []
                if (listImageCurrenDecode.length > 0) {
                    for (let i = 0; i < listImageCurrenDecode.length; i++) {
                        const itemImage = this.initJsonArayListImage(
                            listImageCurrenDecode[i],
                        )
                        arrayListimage.push(itemImage)
                    }
                }
                this.dataListArrayImageTop = arrayListimage
                const emitArrAll: any = {}
                emitArrAll[this.pageActive] =
                    this.pageActive == 'slideshow'
                        ? this.slideshowList
                        : this.dataListArrayImageTop
                emitArrAll[
                    'arrTmpArrClientTop'
                    ] = this.dataListArrayImageTop
                if (this.tabActive == 'dsd' || this.tabActive == 'smile') {
                    emitArrAll['forceDelete'] = true
                    emitArrAll['checkChange'] = true
                } else {
                    emitArrAll['checkChange'] = false
                }
                //update imgFace
                let imageFrontSmile = this.getFrontSmileToAvatar(this.dataListArrayImageTop);
                if (imageFrontSmile !== undefined) {
                    if (typeof this.faceImage === 'undefined') {
                        this.callApiUpdateFaceImage(imageFrontSmile)
                    } else if (this.faceImage !== '') {
                        if (this.faceImage['id'] !== imageFrontSmile['id']) {
                            this.callApiUpdateFaceImage(imageFrontSmile)
                        } else if (imageFrontSmile['matrix'] != undefined && this.faceImage['matrix'] !== imageFrontSmile['matrix'].toString()) {
                            this.callApiUpdateFaceImage(imageFrontSmile)
                        }
                    }
                }
                else {
                    imageFrontSmile = {
                        id: ''
                    }
                    this.callApiUpdateFaceImage(imageFrontSmile)
                }
                //end

                this.clientTopServices.emitChangeAllArrClientTop(
                    emitArrAll,
                )
                if (this.newSlideshowIndex != -1) {
                    const emitIndex: any = {}
                    emitIndex['index'] = this.newSlideshowIndex
                    this.clientTopServices.emitChangeIndex(emitIndex)
                    this.newSlideshowIndex = -1
                } else if (this.newRegistrationIndex != -1) {
                    const emitIndex: any = {}
                    emitIndex['index'] = this.newRegistrationIndex
                    this.clientTopServices.emitChangeIndex(emitIndex)
                    this.newRegistrationIndex = -1
                }
            })
        })
    }

    getArrImg(arrImg,page,index){
        this.clientTopServices.changeArrImg(arrImg,page,index);
    }

    removeRecordSelect(idClientVisit) {
        this.changeLanguage()
        notification.confirm({
            message: this.en['alert-content-2'],
            title: this.en['alert-remove'],
            cancelable: true,
            buttonLabels: [this.en['alert-cancel'], 'OK'],
            callback: (i) => {
                if (i === 1 && idClientVisit[0] !== '') {
                    // here this is not cancelled.  1 is correct.
                    this.callApiRemoveRecornd(idClientVisit)
                    if (this.pageActive == 'slideshow') {
                        this.removeSlideshowRecord(idClientVisit[0])
                        //this.getNewRegistationIndex(idClientVisit[1])
                        //this.dataListArrayImageTop.splice(idClientVisit[1],1)
                        this.getArrImg(this.dataListArrayImageTop,this.pageActive,idClientVisit[1]);
                    }
                     else {
                        this.getNewRegistationIndex(idClientVisit[1])
                    }
                    
                    // this.getNewRegistationIndex(idClientVisit[1])
                    
                }
            },
        })
    }

    getNewRegistationIndex(id) {
        if (id == this.dataListArrayImageTop.length - 1) {
            if (this.dataListArrayImageTop[id - 1]) {
                this.newRegistrationIndex = id - 1
            }            
        }
    }

    removeSlideshowRecord(id) {
        const found = this.slideshowList.findIndex((e) => {
            return e._id == id
        })
        if (found > -1) {
            if (found == 0 && this.slideshowList[found + 1]) {
                this.newSlideshowIndex = 0
            } else if (this.slideshowList[found - 1]) {
                this.newSlideshowIndex = found - 1
            } else if (this.slideshowList[found + 1]) {
                this.newSlideshowIndex = found + 1
            }
            this.slideshowList.splice(found, 1)
        }
    }

    toggleShowImageItem(showimageSelect) {
        if (showimageSelect === false) {
            this.selectShowImageItem = 'tag-button-disabled'
            this.showIconV = 'hidden'
            this.showImage = 'active'
        } else {
            this.selectShowImageItem = ''
            this.showIconV = 'active'
            this.showImage = 'hidden'
        }

        this.showimageSelect = !showimageSelect
    }

    getUrlImage(id) {
        if (id !== '') {
            return imageUrl + id + '?type=medium'
        }
    }

    getStyleImage(object, imageViewData) {
        let stringTranform = this.caculatorMatrix(imageViewData, 58, 38)
        if (object) {
            if (object.rotate) {
                stringTranform += ' rotate(' + object.rotate + 'deg)'
            }
            if (object.scaleX) {
                stringTranform += 'scaleX(' + object.scaleX + ') '
            }
            if (object.scaleY) {
                stringTranform += 'scaleY(' + object.scaleY + ') '
            }
        }
        return {
            transform: stringTranform,
        }
    }

    caculatorMatrix(
        sizeImage,
        widthFrame,
        heightFrame,
        matrixImage = [1, 0, 0, 1],
    ) {
        if (sizeImage.width === 0 && sizeImage.height === 0) return ''
        const widthRatio = widthFrame / sizeImage.width
        const heightRatio = heightFrame / sizeImage.height
        const ratioMin = widthRatio < heightRatio ? widthRatio : heightRatio
        const n1 = ratioMin * matrixImage[0] // n1
        const n2 = (heightFrame / sizeImage.width) * matrixImage[1] // n2
        const n3 = (heightFrame / sizeImage.width) * matrixImage[2] // n3
        const n4 = ratioMin * matrixImage[3] // n4
        const n5 = (widthFrame - sizeImage.width) / 2
        const n6 = (heightFrame - sizeImage.height) / 2
        return (
            'matrix(' +
            n1 +
            ',' +
            n2 +
            ',' +
            n3 +
            ',' +
            n4 +
            ',' +
            n5 +
            ',' +
            n6 +
            ')'
        )
    }

    initJsonArayListImage(json) {
        this.listImage = {}
        this.showList.forEach((name) => {
            if (json[name] === undefined) {
                this.listImage[name] = json[name] = [
                    { id: '' },
                    { id: '' },
                    { id: '' },
                    { id: '' },
                    { id: '' },
                    { id: '' },
                ]
            } else if (json[name] === null) {
                this.listImage[name] = json[name] = [
                    { id: '' },
                    { id: '' },
                    { id: '' },
                    { id: '' },
                    { id: '' },
                    { id: '' },
                ]
            } else {
                this.listImage[name] = json[name]
                if (json[name][0] === null) {
                    json[name][0] = { id: '' }
                }
            }
        })

        this.listImage.dsd = json.dsd
        this.listImage.smile = json.smile

        this.listImage['clientId'] =
            json['clientId'] !== undefined ? json['clientId'] : ''
        this.listImage['createTime'] =
            json['createTime'] !== undefined ? json['createTime'] : ''
        this.listImage['dateString'] =
            json['dateString'] !== undefined ? json['dateString'] : ''
        this.listImage['dateStringToInit'] =
            json['dateStringToInit'] !== undefined
                ? json['dateStringToInit']
                : ''
        this.listImage['updateTime'] =
            json['updateTime'] !== undefined ? json['updateTime'] : ''
        this.listImage['_id'] = json['_id'] !== undefined ? json['_id'] : ''
        return this.listImage
    }

    computeColspan(imgType) {
        if (imgType !== 'SmileFlame' && imgType !== 'Dsd') {
            return 6
        }
        return 1
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/listImage/modal-list-image-top.component.ts